/* eslint-disable max-classes-per-file */
/* eslint-disable no-useless-constructor */
import { CONCEPTS } from '@rover/rsdk/src/concepts';
import type { ConsentPurpose } from '@rover/rsdk/src/modules/Analytics';
import { AnalyticsEvent } from '@rover/types/src/Analytics';

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when a sitter clicks on the "Promote your profile" header item
 *
 * &nbsp;
 */
export class PromoteYourBusinessHeaderClick extends AnalyticsEvent {
  eventName = 'promote-your-business-header-click';

  consentPurpose: ConsentPurpose = 'performance';

  concept = CONCEPTS.marketing.referrals;
}

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when a sitter clicks on the "Invite a Friend" header item
 *
 * &nbsp;
 */
export class ReferralCTAClick extends AnalyticsEvent {
  eventName = 'referral-cta-click';

  consentPurpose: ConsentPurpose = 'performance';

  concept = CONCEPTS.marketing.referrals;

  constructor(
    eventProperties: {
      referralCTA?: string;
    },
    observabilityTags: {
      referralCTA?: string;
    }
  ) {
    super(eventProperties, observabilityTags);
  }
}
